import edjsHTML from 'editorjs-html';
import sanitizeHtml from 'sanitize-html';
import { PostBody } from './editorjs.model';

const errorMessage = () => ({
	time: 1,
	blocks: [
		{
			type: 'header',
			data: {
				text: 'Story not found (321)',
				level: 3,
			},
		},
		{
			type: 'paragraph',
			data: {
				text: `<p className="mb-3 text-base font-medium text-gray-700">
          Sorry, the page you requested has problems with stories!
					Head back to our <a href="/" className="underline">homepage</a>, or take a look at one of the sections below.</p>`,
			},
		},
	],
	version: '0',
});

export const parseJson = (data: string): PostBody => {
	try {
		return JSON.parse(data);
	} catch (e) {
		return errorMessage();
	}
};

export const bodyTransform = (body: string) => {
	const customParser = {
		code: ({ data }) => {
			const { code } = data;
			return `<pre><code>${code}</code></pre>`;
		},

		simpleImage: ({ data }) => {
			const { caption, url } = data;
			return `<img src="${url ? url : ''}" alt="${caption}" />`;
		},
		github: ({ data }) => {
			const { embed, height } = data;
			return `<iframe onload='javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+"px";}(this));' style="height:${height}px;width:100%;border:none;overflow:hidden;" allowfullscreen="0" allowfullscreen 
				srcdoc="<script src='${embed}.js'></script>"></iframe>
			`;
		},
	};

	try {
		const edjsParser = edjsHTML(customParser);
		const bodyJson: PostBody = parseJson(body);
		const bodyFormat = edjsParser.parse(bodyJson).join('');
		return bodyFormat;
	} catch (error) {
		return 'no data';
	}
};

const cleanHtml = (dirtyHtml: string) =>
	sanitizeHtml(dirtyHtml, {
		allowedAttributes: {
			iframe: ['height', 'width', 'src', 'srcdoc', 'style'],
			img: ['src'],
			a: ['href'],
		},
		allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'iframe']),
	});

export const CleanHTML = ({ text }) => {
	const body = bodyTransform(text);
	const cleanBody = cleanHtml(body);

	return (
		<>
			{body && (
				<div
					dangerouslySetInnerHTML={{
						__html: cleanBody,
					}}
				></div>
			)}
		</>
	);
};
